const HOURS_ROWS = [
  { day: '月〜木', time: '08:00 – 17:00', closed: false },
  { day: '金', time: '定休日', closed: true },
  { day: '土・日・祝', time: '11:30 – 18:00', closed: false },
  { day: '祝翌日', time: '定休日', closed: true },
];

const NAV_LINKS = [
  { label: 'About', href: '#about' },
  { label: 'Cafe', href: '#cafe' },
  { label: 'Events', href: '#events' },
  { label: 'Rental', href: '#rental' },
  { label: 'Access', href: '#access' },
  { label: 'FAQ', href: '#faq' },
];

export default function SiteFooter() {
  return (
    <footer className="bg-[#1a1a1a] text-white">
      {/* Main footer grid */}
      <div className="max-w-5xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">

          {/* Col 1 — Brand + SNS */}
          <div className="flex flex-col gap-6">
            <img
              src="https://static.readdy.ai/image/faab8405af96b700637a376baf26c6c6/ce784064396c70f7faf6f634edca28a4.png"
              alt="episode"
              className="h-10 w-auto object-contain"
              style={{ filter: 'brightness(0) invert(1)' }}
            />
            <p
              className="text-xs text-gray-400 leading-relaxed"
              style={{ fontFamily: 'serif', lineHeight: '1.9' }}
            >
              大阪・南森町のカフェ。<br />
              コーヒー、音楽、アート、イベントが<br />
              交差する場所。
            </p>
            <a
              href="https://instagram.com/episode_t21"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 text-gray-400 hover:text-[#A790C4] transition-colors duration-300 cursor-pointer text-sm"
              style={{ fontFamily: 'serif' }}
            >
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-instagram-line text-base"></i>
              </div>
              @episode_t21
            </a>
          </div>

          {/* Col 2 — Hours + Contact */}
          <div className="flex flex-col gap-5">
            <p
              className="text-xs tracking-widest text-gray-500 font-light"
              style={{ letterSpacing: '0.25em' }}
            >
              HOURS &amp; CONTACT
            </p>

            {/* Hours mini-table */}
            <div className="space-y-1.5">
              {HOURS_ROWS.map((row, i) => (
                <div key={i} className="flex items-center justify-between gap-4">
                  <span
                    className="text-xs text-gray-400 w-20 flex-shrink-0"
                    style={{ fontFamily: 'serif' }}
                  >
                    {row.day}
                  </span>
                  <span
                    className={`text-xs flex-1 text-right ${row.closed ? 'text-gray-600' : 'text-gray-300'}`}
                    style={{ fontFamily: 'serif' }}
                  >
                    {row.time}
                  </span>
                </div>
              ))}
            </div>

            <div className="w-full h-px bg-white/10 rounded-full"></div>

            {/* Phone */}
            <a
              href="tel:0663533456"
              className="inline-flex items-center gap-2 text-gray-300 hover:text-[#A790C4] transition-colors duration-300 cursor-pointer"
              style={{ fontFamily: 'serif' }}
            >
              <div className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                <i className="ri-phone-line text-sm"></i>
              </div>
              <span className="text-sm tracking-wide">06-6353-3456</span>
            </a>

            {/* Instagram DM note */}
            <p className="text-xs text-gray-500 leading-relaxed" style={{ fontFamily: 'serif', lineHeight: '1.8' }}>
              レンタル・イベントのご相談は<br />
              Instagram DM にてお気軽にどうぞ
            </p>
          </div>

          {/* Col 3 — Address + Nav */}
          <div className="flex flex-col gap-5">
            <p
              className="text-xs tracking-widest text-gray-500 font-light"
              style={{ letterSpacing: '0.25em' }}
            >
              ACCESS
            </p>

            {/* Address block */}
            <address className="not-italic space-y-1">
              <p className="text-sm text-gray-300" style={{ fontFamily: 'serif' }}>
                大阪府大阪市北区紅梅町2-3
              </p>
              <p className="text-xs text-gray-500" style={{ fontFamily: 'serif' }}>
                2-3 Kobai-cho, Kita-ku, Osaka 530-0041
              </p>
              <div className="pt-2 space-y-1">
                <p className="text-xs text-gray-500 flex items-center gap-1.5" style={{ fontFamily: 'serif' }}>
                  <span className="w-1 h-1 rounded-full bg-[#A790C4] inline-block flex-shrink-0"></span>
                  南森町駅 徒歩3分
                </p>
                <p className="text-xs text-gray-500 flex items-center gap-1.5" style={{ fontFamily: 'serif' }}>
                  <span className="w-1 h-1 rounded-full bg-[#386663] inline-block flex-shrink-0"></span>
                  大阪天満宮駅 徒歩3分
                </p>
              </div>
            </address>

            <div className="w-full h-px bg-white/10 rounded-full"></div>

            {/* Nav links */}
            <nav className="grid grid-cols-2 gap-x-4 gap-y-2">
              {NAV_LINKS.map((link) => (
                <a
                  key={link.label}
                  href={link.href}
                  className="text-xs text-gray-500 hover:text-[#A790C4] transition-colors duration-300 cursor-pointer tracking-wider"
                  style={{ fontFamily: 'serif' }}
                >
                  {link.label}
                </a>
              ))}
            </nav>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-white/10">
        <div className="max-w-5xl mx-auto px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-gray-600 font-light tracking-wide" style={{ fontFamily: 'serif' }}>
            ©︎episode All Rights Reserved.
          </p>
          <p className="text-xs text-gray-700 font-light" style={{ fontFamily: 'serif' }}>
            大阪・南森町カフェ / イベントスペース / レンタルスペース
          </p>
        </div>
      </div>
    </footer>
  );
}